/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClusterReliabilityMetrics } from '../models';
// @ts-ignore
import type { OrganizationClustersReliabilityMetrics } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * ReliabilityMetricsAPIApi - axios parameter creator
 * @export
 */
export const ReliabilityMetricsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns cluster-level reliability metrics (request rate, error rate, latency percentiles).
         * @summary Returns cluster-level reliability metrics
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [startTime] Filter items to include from specified time.
         * @param {string} [endTime] Filter items to include up to specified time.
         * @param {ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum} [step] Granularity of aggregated data points. Defaults to ONE_DAY when unspecified.
         * @param {string} [timeZone] Timezone for time-based aggregation, default UTC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliabilityMetricsAPIGetClusterReliabilityMetrics: async (organizationId: string, clusterId: string, startTime?: string, endTime?: string, step?: ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('reliabilityMetricsAPIGetClusterReliabilityMetrics', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('reliabilityMetricsAPIGetClusterReliabilityMetrics', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/reliability-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a reliability metrics summary per cluster for an organization.
         * @summary Returns reliability metrics summary per cluster for an organization
         * @param {string} organizationId ID of the organization.
         * @param {string} [startTime] Filter items to include from specified time.
         * @param {string} [endTime] Filter items to include up to specified time.
         * @param {string} [timeZone] Timezone for time-based aggregation, default UTC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics: async (organizationId: string, startTime?: string, endTime?: string, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics', 'organizationId', organizationId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/reliability-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReliabilityMetricsAPIApi - functional programming interface
 * @export
 */
export const ReliabilityMetricsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReliabilityMetricsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns cluster-level reliability metrics (request rate, error rate, latency percentiles).
         * @summary Returns cluster-level reliability metrics
         * @param {string} organizationId ID of the organization.
         * @param {string} clusterId ID of the cluster.
         * @param {string} [startTime] Filter items to include from specified time.
         * @param {string} [endTime] Filter items to include up to specified time.
         * @param {ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum} [step] Granularity of aggregated data points. Defaults to ONE_DAY when unspecified.
         * @param {string} [timeZone] Timezone for time-based aggregation, default UTC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reliabilityMetricsAPIGetClusterReliabilityMetrics(organizationId: string, clusterId: string, startTime?: string, endTime?: string, step?: ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterReliabilityMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reliabilityMetricsAPIGetClusterReliabilityMetrics(organizationId, clusterId, startTime, endTime, step, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReliabilityMetricsAPIApi.reliabilityMetricsAPIGetClusterReliabilityMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a reliability metrics summary per cluster for an organization.
         * @summary Returns reliability metrics summary per cluster for an organization
         * @param {string} organizationId ID of the organization.
         * @param {string} [startTime] Filter items to include from specified time.
         * @param {string} [endTime] Filter items to include up to specified time.
         * @param {string} [timeZone] Timezone for time-based aggregation, default UTC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics(organizationId: string, startTime?: string, endTime?: string, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationClustersReliabilityMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics(organizationId, startTime, endTime, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReliabilityMetricsAPIApi.reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReliabilityMetricsAPIApi - factory interface
 * @export
 */
export const ReliabilityMetricsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReliabilityMetricsAPIApiFp(configuration)
    return {
        /**
         * Returns cluster-level reliability metrics (request rate, error rate, latency percentiles).
         * @summary Returns cluster-level reliability metrics
         * @param {ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliabilityMetricsAPIGetClusterReliabilityMetrics(requestParameters: ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClusterReliabilityMetrics> {
            return localVarFp.reliabilityMetricsAPIGetClusterReliabilityMetrics(requestParameters.organizationId, requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a reliability metrics summary per cluster for an organization.
         * @summary Returns reliability metrics summary per cluster for an organization
         * @param {ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics(requestParameters: ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationClustersReliabilityMetrics> {
            return localVarFp.reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics(requestParameters.organizationId, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reliabilityMetricsAPIGetClusterReliabilityMetrics operation in ReliabilityMetricsAPIApi.
 * @export
 * @interface ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetricsRequest
 */
export interface ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetricsRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetrics
     */
    readonly organizationId: string

    /**
     * ID of the cluster.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetrics
     */
    readonly clusterId: string

    /**
     * Filter items to include from specified time.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetrics
     */
    readonly startTime?: string

    /**
     * Filter items to include up to specified time.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetrics
     */
    readonly endTime?: string

    /**
     * Granularity of aggregated data points. Defaults to ONE_DAY when unspecified.
     * @type {'STEP_UNSPECIFIED' | 'ONE_MINUTE' | 'FIVE_MINUTES' | 'ONE_HOUR' | 'ONE_DAY'}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetrics
     */
    readonly step?: ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum

    /**
     * Timezone for time-based aggregation, default UTC.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetrics
     */
    readonly timeZone?: string
}

/**
 * Request parameters for reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics operation in ReliabilityMetricsAPIApi.
 * @export
 * @interface ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetricsRequest
 */
export interface ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetricsRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics
     */
    readonly organizationId: string

    /**
     * Filter items to include from specified time.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics
     */
    readonly startTime?: string

    /**
     * Filter items to include up to specified time.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics
     */
    readonly endTime?: string

    /**
     * Timezone for time-based aggregation, default UTC.
     * @type {string}
     * @memberof ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics
     */
    readonly timeZone?: string
}

/**
 * ReliabilityMetricsAPIApi - object-oriented interface
 * @export
 * @class ReliabilityMetricsAPIApi
 * @extends {BaseAPI}
 */
export class ReliabilityMetricsAPIApi extends BaseAPI {
    /**
     * Returns cluster-level reliability metrics (request rate, error rate, latency percentiles).
     * @summary Returns cluster-level reliability metrics
     * @param {ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReliabilityMetricsAPIApi
     */
    public reliabilityMetricsAPIGetClusterReliabilityMetrics(requestParameters: ReliabilityMetricsAPIApiReliabilityMetricsAPIGetClusterReliabilityMetricsRequest, options?: RawAxiosRequestConfig) {
        return ReliabilityMetricsAPIApiFp(this.configuration).reliabilityMetricsAPIGetClusterReliabilityMetrics(requestParameters.organizationId, requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a reliability metrics summary per cluster for an organization.
     * @summary Returns reliability metrics summary per cluster for an organization
     * @param {ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReliabilityMetricsAPIApi
     */
    public reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics(requestParameters: ReliabilityMetricsAPIApiReliabilityMetricsAPIGetOrganizationClustersReliabilityMetricsRequest, options?: RawAxiosRequestConfig) {
        return ReliabilityMetricsAPIApiFp(this.configuration).reliabilityMetricsAPIGetOrganizationClustersReliabilityMetrics(requestParameters.organizationId, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum = {
    STEP_UNSPECIFIED: 'STEP_UNSPECIFIED',
    ONE_MINUTE: 'ONE_MINUTE',
    FIVE_MINUTES: 'FIVE_MINUTES',
    ONE_HOUR: 'ONE_HOUR',
    ONE_DAY: 'ONE_DAY'
} as const;
export type ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum = typeof ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum[keyof typeof ReliabilityMetricsAPIGetClusterReliabilityMetricsStepEnum];
